"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (t, e) {
  for (var r in e) {
    t[r] = e[r];
  }
}(exports, function (t) {
  var e = {};function r(n) {
    if (e[n]) return e[n].exports;var o = e[n] = { i: n, l: !1, exports: {} };return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }return r.m = t, r.c = e, r.d = function (t, e, n) {
    r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
  }, r.t = function (t, e) {
    if (1 & e && (t = r(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var n = Object.create(null);if (r.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var o in t) {
      r.d(n, o, function (e) {
        return t[e];
      }.bind(null, o));
    }return n;
  }, r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return r.d(e, "a", e), e;
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.p = "", r(r.s = 233);
}({ 233: function _(t, e, r) {
    t.exports = r(234);
  }, 234: function _(t, e, r) {
    "use strict";
    r.r(e), r.d(e, "Switch", function () {
      return n;
    });
    var n = function () {
      function n(t) {
        var _this = this;

        _classCallCheck(this, n);

        this.switchNode = t, this.switchNode.addEventListener("click", function () {
          return _this.toggleStatus();
        }), this.switchNode.addEventListener("keydown", function (t) {
          return _this.handleKeydown(t);
        });
      }

      _createClass(n, [{
        key: "handleKeydown",
        value: function handleKeydown(t) {
          "Enter" !== t.key && " " !== t.key || (t.preventDefault(), this.toggleStatus());
        }
      }, {
        key: "toggleStatus",
        value: function toggleStatus() {
          var t = "true" === this.switchNode.getAttribute("aria-checked"),
              e = String(!t);this.switchNode.setAttribute("aria-checked", e);
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-switch]";
        }
      }]);

      return n;
    }();
  } }));